import React from 'react';
import { useLocation, useOutletContext, Link } from 'react-router-dom';
import { Row, Col, Container, Placeholder, Card, Carousel } from 'react-bootstrap';

const DetailedReference = () => {
  const location = useLocation();
  const { l } = useOutletContext();
  const { reference } = location.state || {};

  // Determine the back path based on reference type
  const getBackPath = () => {
    if (!reference) return '/references';
    switch (reference.type) {
      case 'Tests':
        return '/tests';
      case 'Reports':
        return '/reports';
      case 'Customer Testimonials':
      default:
        return '/references';
    }
  };

  const getBackLabel = () => {
    if (!reference) return { swe: 'Till referenser', eng: 'Back to references' };
    switch (reference.type) {
      case 'Tests':
        return { swe: 'Tester', eng: 'Tests' };
      case 'Reports':
        return { swe: 'Rapporter', eng: 'Reports' };
      case 'Customer Testimonials':
      default:
        return { swe: 'Kundutlåtanden', eng: 'Customer Testimonials' };
    }
  };

  const backPath = getBackPath();
  const backLabel = getBackLabel();

  if (!reference) {
    return (
      <Container className="py-5">
        <h1 className="fw-bold mb-3">{l('Referens saknas', 'Reference not found')}</h1>
        <Link to={backPath} style={{ textDecoration: 'none', color: 'var(--newRed2)' }}>
          <i className="fa fa-arrow-left" />&nbsp;&nbsp;{l(backLabel.swe, backLabel.eng)}
        </Link>
      </Container>
    );
  };

  const imageFiles = reference.fileContent.filter(file => ['.jpg', '.jpeg', '.png', '.gif'].some(ext => file.file && file.file.endsWith(ext)));
  const referenceFiles = reference.fileContent.filter(file => !['.jpg', '.jpeg', '.png', '.gif'].some(ext => file.file && file.file.endsWith(ext)));
  
  return (
    <>


      <Container className='my-lg-5 my-3'>

        <Row className="align-items-center">
          {/* Arrow link first on small/medium, second on large */}
          <Col xs={12} lg="auto" className="order-1 order-lg-2 text-lg-end">
            <Link
              to={backPath}
              className="mx-3"
              style={{ textDecoration: 'none', color: 'var(--newRed2)' }}
            >
              <i className="fa fa-arrow-left"></i>&nbsp;&nbsp;
              {l(backLabel.swe, backLabel.eng)}
            </Link>
          </Col>

          {/* Product name second on small/medium, first on large */}
          <Col xs={12} lg={6} className="order-2 order-lg-1 mt-lg-0 mt-3">
            <h1 className="mb-3 fw-bold text-lg-start text-center">{l(reference.titleSwe, reference.titleEng)}</h1>
          </Col>
        </Row>

        {/* Main content: image + description */}
        <Row>

          {imageFiles.length > 0 && <Col xs={12} md={5} lg={4} className="d-flex justify-content-center justify-content-md-start">
            <Carousel>

              {imageFiles.map((file, index) => (
                <Carousel.Item key={index}>
                  <img
                    className="d-block w-100"
                    src={file.file}
                    alt={l(reference.titleSwe, reference.titleEng)}
                  />
                </Carousel.Item>
              ))}

            </Carousel>
          </Col>}


          <Col xs={12} md={7} lg={8}>
            <p className="lead mb-0 reference-content">{l(reference.contentSwe, reference.contentEng)}</p>
          </Col>
        </Row>

        {/* Data sheets box */}
        <Row className="mt-4">
          <Col xs={12} md={8} lg={6} xl={5}>
            <div className="p-3 border rounded-3">
              <h3 className="mb-4">{l('Filer', 'Files')}</h3>
              {referenceFiles.length > 0 ? (
                referenceFiles.map((file, index) => (
                  <div key={index} className="mb-3">
                    <Link to={file.file} style={{ textDecoration: 'none' }} reloadDocument>
                      <p className="mb-0">{l(file.titleSv, file.titleEn)}</p>
                    </Link>
                  </div>
                ))
              ) : (
                <p className="mb-0">{l('Inga datablad tillgängliga', 'No data sheets available')}</p>
              )}
            </div>
          </Col>
        </Row>

      </Container>
    </>
  );
};

export default DetailedReference;
